export default __webpack_public_path__ + "static/media/Belt of Ardent Fire.635f9ae4.jpg";